import React, { useEffect, useState } from 'react'
import consumer from '../channels/consumer'

const ProgressUsage = ({ max_actions_per_month, total_actions_used }) => {
  const [totalActionsUsed, setTotalActionsUsed] = useState(total_actions_used);
  const [maxActionsPerMonth, setMaxActionsPerMonth] = useState(max_actions_per_month);
  const [isAnimating, setIsAnimating] = useState(false);
  const percentage = ((totalActionsUsed / maxActionsPerMonth) * 100).toFixed(2)

  const progress_color_class = (percentage) => {
    if (percentage >= 80) return 'progress-error'
    if (percentage >= 50) return 'progress-warning'
    return 'progress-success'
  }

  useEffect(() => {
    const subscription = consumer.subscriptions.create('ContentResultChannel', {
      received(data) {
        if (data.type === 'increase_user_count') {
          const { total_actions_used, max_actions_per_month } = data.user_stats;
          setTotalActionsUsed(total_actions_used);
          setMaxActionsPerMonth(max_actions_per_month);
          setIsAnimating(true);
          setTimeout(() => setIsAnimating(false), 300);
        }
      },
    })

    return () => {
      subscription.unsubscribe()
    }
  }, [])

  return (
    <div className="p-2 mb-2">
      <div className={`flex-1 transition-all duration-300 ${isAnimating ? 'scale-105 animate-pulse border-2 border-error' : ''}`}>
        <div className="flex justify-between mb-1">
          <span
            className="text-sm font-sans">Usage Limit ({maxActionsPerMonth}/{totalActionsUsed}
            )</span>
          <span className="text-sm font-medium ml-1">{percentage}%</span>
        </div>
        <progress
          className={`progress ${progress_color_class(percentage)} w-full h-4`}
          value={totalActionsUsed}
          max={maxActionsPerMonth}></progress>
      </div>
    </div>
  )
}

export default ProgressUsage